import React, { useEffect, useState, useContext } from "react";
import Cookies from "js-cookie";
import ShopButton from "../../elements/ShopButton";
import NewsletterInput from "../../elements/NewsletterInput";
import { UserContext } from "../../context/UserContext";

const NewsletterForm = () => {
  const [showNewsletterModal, setShowNewsletterModal] = useState(false);
  const [newsletterAccepted, setNewsletterAccepted] = useState(false);
  const [signupComplete, setSignupComplete] = useState(false);

  const { user } = useContext(UserContext);


  // Trigger modal on scroll
  useEffect(() => {
    const handleScroll = () => {
      const newsletterResponded = Cookies.get("newsletterResponded");
      if (!user && !newsletterResponded && window.scrollY >= window.innerHeight) {
        setShowNewsletterModal(true);
        window.removeEventListener("scroll", handleScroll);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDeclineNewsletter = () => {
    Cookies.set("newsletterResponded", true, { expires: 1 });
    setShowNewsletterModal(false);
  };

  // If modal is not shown or already accepted, don't render anything
  if (!showNewsletterModal || newsletterAccepted) return null;

  return (
    <div style={styles.modalArea}>
      <div style={{ ...styles.modal, flexDirection: "column" }}>
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            background: "#1E1E1E",
            borderRadius: "12px",
            overflow: "hidden",
            border: "1px solid white",
          }}
        >
          <div style={{ ...styles.modalContent, width: "100%", justifyContent: "flex-end", display: "flex", position: "relative" }}>
            <div onClick={handleDeclineNewsletter} style={styles.closeButtonArea}>
              &times;
            </div>
          </div>
          <div
            style={{
              padding: "15px",
              zIndex: 1,
              backgroundImage: "url('/images/newsletter.png')",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              aspectRatio: "2/1.5",
              display: "flex",
              flexDirection: "column",
              position: "relative",
            }}
          >
            <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 0 }}></div>
            <div style={{ flex: 1, display: "flex", zIndex: 1, alignItems: "flex-start" }}>
              <img src="/images/fullproof_logo_white.svg" alt="Fullproof" style={{ width: "50%" }} />
            </div>
            <div style={{ display: "flex", color: "white", fontSize: "1.5rem", fontWeight: 800, zIndex: 1 }}>
              {!signupComplete ? "Unlock 20% off your first order." : "20% off is on its way to your inbox."}
            </div>
          </div>
          <div>
            <div style={{ display: "flex", flex: 1, alignItems: "flex-start", textAlign: "center" }}>
              <div style={{ display: "flex", flexDirection: "column", padding: "10px", width: "100%" }}>
                {!signupComplete ? (
                  // Pass the callback to update signupComplete state in the parent
                  <NewsletterInput onSignupComplete={() => setSignupComplete(true)} buttonText={"Get 20% off"} />
                ) : (
                  <div style={{ color: "white" }}>
                    <div style={{ fontSize: "1.5rem", fontWeight: "600", padding: "5px 0" }}>You’re in!</div>
                    <div style={{ fontSize: ".8rem", fontWeight: "500", padding: "10px 0px" }}>
                      Welcome to the club. Amazing products
                      <br />
                      and offers are in your future. Enjoy!
                    </div>
                    {/* You can change this button's onClick to perform a different action, such as closing the modal */}
                    <ShopButton text="Continue Shopping" theme="light" onClick={handleDeclineNewsletter} style={{ ...styles.modalButton, width: "100%" }} />
                    <div style={{ fontSize: ".6rem", color: "white", textAlign: "justify", padding: "5px 0" }}>
                      Join our newsletter for exclusive product recommendations and serious savings. Unsubscribe with the click of a button.
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  modalArea: {
    display: "flex",
    padding: 10,
    position: "fixed",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(2px)",
    WebkitBackdropFilter: "blur(2px)",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2000,
  },
  modal: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContent: {
    textAlign: "center",
  },
  modalButton: {
    backgroundColor: "#000",
    color: "#fff",
    padding: "10px 20px",
    borderRadius: "5px",
    cursor: "pointer",
  },
  closeButtonArea: {
    position: "absolute",
    fontSize: "1.7rem",
    cursor: "pointer",
    right: 0,
    top: 10,
    width: 50,
    height: 50,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1001,
    color: "white",
  },
};

export default NewsletterForm;
